import React, { useEffect, useState } from "react";
import LiveFanImage from "../../../assets/Icon/live.png";
import axios from "axios";
import AllDataHeader from "../../../Components/Reuseable/AllDataHeader";
import AllModuleData from "../../../Components/Reuseable/AllModuleData";
import LoaderPost from "../../../Components/Reuseable/LoaderPost";

const AcceptedFan = () => {
  const [event_data, setAllFanAccept] = useState([]);
  const [buffer, setBuffer] = useState(true);
  useEffect(() => {
    axios.get("/api/star/fan/group/starlist/status").then((res) => {
      setBuffer(false);
      if (res.data.status === 200) {
        setAllFanAccept(res.data.starApproved);
      }
    });
  }, []);

  return (
    <>
      <AllDataHeader
        title="Accepted || Approved Fan Group"
        image={LiveFanImage}
        count={event_data.length}
      />
      {buffer ? (
        <LoaderPost />
      ) : (
        <AllModuleData
          data={event_data}
          urlLink={`/superstar/fan-group-accepted/details`}
          fan={"true"}
        />
      )}
    </>
  );
};

export default AcceptedFan;
